exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "table.grid td.grid-editable-cell {\n  position: relative;\n}\ntable.grid td.grid-editable-cell .grid-edit-icon {\n  display: none;\n  position: absolute;\n  top: 2px;\n  right: 2px;\n  font-size: 10px;\n}\ntable.grid td.grid-editable-cell:hover .grid-edit-icon {\n  display: block;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./less/editable.less
// module id = 36
// module chunks = 0